import { createEntityAdapter, type EntityAdapter, type EntityState } from '@ngrx/entity';
import type { Project } from '../../../interfaces/Project.interface';

export const projectAdapter: EntityAdapter<Project> = createEntityAdapter({
    selectId: project => project.projectId
});

export interface State extends EntityState<Project> {
    currentProjectId: string | null;
    isChanging: boolean;
    isPending: boolean;
    isLoaded: boolean;
}

export const initialState: State = projectAdapter.getInitialState({
    currentProjectId: null,
    isChanging: false,
    isPending: false,
    isLoaded: false
});
